"use client";

import { useState } from "react";
import { motion } from "motion/react";
import { TestimonialCard } from "./TestimonialCard";
import { testimonials } from "../data";
import { fadeInVariants } from "@/lib/animations";

export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const handleNext = () => {
    setDirection(1);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <motion.section
      className="relative overflow-hidden"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeInVariants}
    >
      <TestimonialCard
        id={currentTestimonial.id}
        bgImageUrl={currentTestimonial.bgImageUrl}
        message={currentTestimonial.message}
        onNext={handleNext}
        onPrev={handlePrev}
        direction={direction}
      />
    </motion.section>
  );
}
